import "./scrollUp.scss";
import { ReactComponent as ArrowUp } from "../../assets/arrow-up.svg";
import { useEffect, useState } from "react";

const ScrollUp = () => {
  const [classes, setClasses] = useState("button hidden");

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const scroll = window.scrollY;
      const requirementsSection = document.getElementById("requirements");
      setClasses(
        requirementsSection && scroll > requirementsSection.scrollHeight
          ? "button"
          : "button hidden"
      );
    });
  }, []);

  return (
    <div className="scroll-up-container">
      <button onClick={() => scrollToTop()} className={classes}>
        <ArrowUp />
      </button>
    </div>
  );
};

export default ScrollUp;
